import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const DEFAULT_URL = "";

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const ENTER_SITE_URL = "https://a.ntrk2.com/97faa6a9-dcb8-452a-aa3e-819e163caacd";
export const DOWNLOAD_URL = "https://wowjili.kzw2a.com/download?openExternalBrowser=1&id=kem6ab0jl6pqdlw";

export * from "./codes";
export * from "./context";
